import { useContext } from 'react';

import { DeleteGoalSectionContext } from './delete-goal-section-context';

export const useOpenDeleteGoalSectionDialog = () => {
  const { onDeleteGoalSection } = useContext(DeleteGoalSectionContext);

  return onDeleteGoalSection;
};
